export const containerCss = {
  display: "flex",
  flexDirection: "column",
  gap: 25,
};
